(function () {
	'use strict';

	var ofi = require('object-fit-images');

	ofi();
})();
